export default __webpack_public_path__ + "static/fill-img01-76b0c4d84cb0a05d4ce5088310fe5e1a.svg";